var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-card"},[_c('h5',[_vm._v("ACCUMULATED CAPITAL GAIN V.S. TENURE PERIOD")]),_c('div',{staticClass:"scatter-chart-wrap"},[_c('canvas',{ref:"canvas"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }